// Integration discovery + request api fns — carved verbatim from
// `src/api/scribeAPIV2.ts` (which now re-exports them) as D1 of the
// `integrations/connected-apps` family (ARCFE-1087).
//
// These are the `/integrations/**` routes that CHOOSE or PROVISION an
// integration rather than use one, which is the line that separates this door
// from `./ehr` (task 3.9, ARCFE-1015).
//
// `createIntegrationContactSalesRequest` and `getIntegrationContactSalesRequest`
// are declared `async` in the hub without awaiting anything. That is preserved:
// dropping the keyword would change the returned promise identity for callers
// that compare it, and this carve changes no signatures.
import type {
  ContactSalesRequestBase,
  CreateContactSalesRequestResponse,
  CreateNewIntegrationRequestResponse,
  GetAvailableDirectIntegrationsResponse,
  GetIntegrationCapabilitiesResponse,
  IntegrationClientMode,
  IntegrationRequestBase,
} from '../../contracts/types';
import { http } from './connectedAppsHttp';

import type { EHRProvider } from '@heidi/schema/ml-scribe';

export const getAvailableDirectIntegrations = () => {
  return http().get<GetAvailableDirectIntegrationsResponse>(`/integrations/available`);
};

export const getIntegrationCapabilities = (
  provider: EHRProvider | string,
  mode?: IntegrationClientMode
) => {
  const url = `/integrations/capabilities/${provider}`;
  return mode
    ? http().get<GetIntegrationCapabilitiesResponse>(url, { params: { mode } })
    : http().get<GetIntegrationCapabilitiesResponse>(url);
};

export const requestEHRIntegration = (input: IntegrationRequestBase) => {
  return http().post<CreateNewIntegrationRequestResponse>(
    `/integrations/integration-request`,
    input
  );
};

export const createIntegrationContactSalesRequest = async (
  body: ContactSalesRequestBase
) => {
  return http().post<CreateContactSalesRequestResponse>(
    `/integrations/integration-request/contact-sales`,
    body
  );
};

export const getIntegrationContactSalesRequest = async ({
  integrationName,
}: {
  integrationName: string;
}) => {
  return http().get<CreateContactSalesRequestResponse>(
    `/integrations/integration-request/contact-sales`,
    {
      params: {
        integration_name: integrationName,
      },
    }
  );
};
